<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>债券管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="债券代码">
				<el-input v-model="formInline.bondCode"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(317)">新增</el-button>
			
			
				<el-upload
				:action=url
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:on-preview="handlePreview"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				multiple
				:limit="limitUpload"
				:on-exceed="handleExceed"
				:with-credentials="true"
				:headers="headers"
				:file-list="fileList">
				<el-button  size="small" type="danger" @click="handlePreview"  v-if="jurisdiction.includes(323)">导入</el-button>
				</el-upload>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column sortable prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
			<el-table-column prop="bondName" label="债券简称" align="center"></el-table-column>
			<el-table-column prop="bondStartTime" label="起息时间" align="center"></el-table-column>
			<el-table-column prop="bondTerm" label="期限" align="center"></el-table-column>
			<el-table-column prop="rate" label="年利率【%】" align="center"></el-table-column>
			<el-table-column prop="rateTimesYear" label="年付息次数" align="center"></el-table-column>
			<el-table-column prop="rateType" label="利率类型" align="center"></el-table-column>
			<el-table-column prop="rateCalaType" label="计息方式" align="center"></el-table-column>
			<el-table-column prop="rateBase" label="利率基础" align="center"></el-table-column>
			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;"  v-if="jurisdiction.includes(317)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)"  v-if="jurisdiction.includes(318)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form :rules="rules" :model="editForm">
				<el-form-item label="债券代码：" label-width="120px">
				<el-input v-model="editForm.bondCode" width="200px"></el-input>
				</el-form-item>
				<el-form-item label="债券简称:" label-width="120px">
				<el-input v-model="editForm.bondName" width="200px"></el-input>
				</el-form-item>
				<el-form-item label="起息时间：" label-width="120px">
					<el-date-picker v-model="editForm.bondStartTime" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="期限：" label-width="120px">
				<el-input v-model="editForm.bondTerm"></el-input>
				</el-form-item>
				<el-form-item label="年利率【%】：" label-width="120px">
				<el-input v-model="editForm.rate"></el-input>
				</el-form-item>
				<el-form-item label="年付息次数：" label-width="120px">
				<el-input v-model="editForm.rateTimesYear"></el-input>
				</el-form-item>
				<el-form-item label="利率类型：" label-width="120px">
				<el-input v-model="editForm.rateType"></el-input>
				</el-form-item>
				<el-form-item label="计息方式：" label-width="120px">
				<el-input v-model="editForm.rateCalaType"></el-input>
				</el-form-item>
				<el-form-item label="利率基础:" label-width="120px">
				<el-input v-model="editForm.rateBase"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="addEdit" >设置</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		addEditBondBase,
		delBondBase,
		getBondList
	} from '../../api/basisMG.js'

	export default {
		data() { 
			return {
				url:localStorage.getItem("baseUrl")+"/manager/bond/importBondBase",
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				editForm: {},
				dialogVisible:false,
				listData: []
			}
		},
		watch: {},

		methods: {
			// 获得数据
			getdata() {
				let param = this.formInline
				getBondList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditBondBase(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },

			// 删除
			handledelete(row) {
				let msg = '确认删除' + row.bondCode +'?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delBondBase({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},

		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>